import { FieldProps } from "formik";
import React from "react";

export interface CheckboxProps {
	defaultChecked?: boolean;
	field?: FieldProps["field"];
	form?: FieldProps["form"];
	id: string;
	label: string | React.ReactNode;
	name?: string;
	value?: boolean;
	onChecked?: (e: any) => void;
	onUnchecked?: (e: any) => void;
	className?: string;
	labelClassName?: string;
	helpText?: string;
}

const CheckboxInput: React.FC<CheckboxProps> = ({
	defaultChecked,
	field,
	form,
	id,
	label,
	onChecked,
	onUnchecked,
	value,
	labelClassName,
	helpText,
	...props
}) => {
	const checkboxChange = (e: any) => {
		if (form && field) {
			form.setFieldValue(field.name, !field.value);
		}
		const { checked } = e.target;
		if (checked && onChecked) {
			onChecked(e);
		} else if (!checked && onUnchecked) {
			onUnchecked(e);
		}
	};

	return (
		<div className="brushfire-checkbox">
			<label
				className={`${labelClassName ? labelClassName : "checkbox"} ${field && field.value ? "active" : ""}`}
				htmlFor={id}
			>
				<input
					type="checkbox"
					defaultChecked={defaultChecked}
					id={id}
					{...field}
					onChange={checkboxChange}
					checked={field && field.value}
					{...props}
				/>
				<span>{label}</span>
			</label>
			{helpText && <small>{helpText}</small>}
		</div>
	);
};
CheckboxInput.displayName = "CheckboxInput";
export default CheckboxInput;
